/**
* 半角変換のコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = FormHalf = function(el){
  this.element = $(el);
  this.timer;
  this.event();
};

/**
* イベント
*/
FormHalf.prototype.event = function(){
  var self = this;
  this.element.on('change',function(e){
    var value = $(this).val();
    var newValue = self.changeToHalf(value);
    $(this).val(newValue);
  });
};

/**
* 変換
* @param {string} value - 値
*/
FormHalf.prototype.changeToHalf = function(value){
  var self = this;
  var halfVal = value.replace(/[！-～]/g, function(value){
    return String.fromCharCode(value.charCodeAt(0) - 0xFEE0);
  });
  return halfVal.replace(/”/g, "\"")
    .replace(/’/g, "'")
    .replace(/‘/g, "`")
    .replace(/￥/g, "\\")
    .replace(/　/g, " ")
    .replace(/〜/g, "~");
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/formHalf.js
// module id = 5
// module chunks = 0